import $ from 'jquery';

export default function alert() {
    let $alertContainer = $('.js-sw-alert'),
        $alertContent = $alertContainer.find('.sw-alert__content');
    setInterval(function(){
        $alertContent.toggleClass("bounce");
    }, 3000);
}